<template>
  <footer class="footer">
      <hr>

      <div class="lower">
          <p>&copy;2023, Thriberx Engineering Pvt Ltd. All rights reserved.
              <RouterLink to="/PrivacyPolicy" class="privacypolicy"> Privacy Policy </RouterLink>
          </p>
          <div class="image1">
              <a href="https://www.facebook.com/profile.php?id=100094732093918">
                  <button class="social-button">
                      <img src="../assets/Facebook.png" alt="Facebook">
                  </button>
              </a>
              <a href="https://instagram.com/thribertech?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D">
                  <button class="social-button">
                      <img src="../assets/Instagram.png" alt="Instagram">
                  </button>
              </a>
              <a href="https://www.linkedin.com/company/thriberx/">
                  <button class="social-button">
                      <img src="../assets/Linkedin(2).png" alt="LinkedIn">
                  </button>
              </a>
          </div>
      </div>
  </footer>
</template>

<script>
import { RouterLink } from 'vue-router';
export default {
  name: 'FooterSection',
  components: { RouterLink }
}
</script>

<style>
.footer {
  text-align: center;
  padding: 2%;
  background-color: #000;
  color: white;
}
.upper{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.logoimg{
  max-width: 5%;
}

.lower{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.image1{
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.privacypolicy{
  text-decoration: none;
  color: #fff;
}
</style>
